// extracted by mini-css-extract-plugin
module.exports = {"link":"_cloudName__link__EQV51","stackDescription":"_cloudName__stackDescription__a_EH7"};